import { FC, useState } from "react";
import { useTrans } from "../hooks";
import { Text, Flex, Input, VStack, Stack, HStack } from "@chakra-ui/react";
import { AppIcon } from "./AppIcon";
import { APPC } from "../config";

type AppFileUploaderProps = {
    fileType: string;
    onFileSelect: (file: File | undefined) => void;
    fileName?: string | undefined | null;
    uploadLabel?: string;
    iconName?: string;
    errorMessage?: string;
};

export const AppFileUploader: FC<AppFileUploaderProps> = ({
    fileType,
    onFileSelect,
    fileName = "",
    uploadLabel = "",
    iconName = "icl-file",
    errorMessage = "",
}) => {
    // hook
    const { t } = useTrans();
    const [errorMsg, setErrorMsg] = useState<string | undefined>();

    // state & const
    const fileTypeInfo =
        APPC.BE.Upload.FILETYPEINFO[`FILETYPEINFO_${fileType}`];

    return (
        <Flex w="full" flexDir={"column"} position={"relative"}>
            <VStack
                w="full"
                h={"180px"}
                p={2}
                gap={3}
                justifyContent={"center"}
                bg={"var(--chakra-colors-primaryT95)"}
                border={"1px dashed var(--chakra-colors-primary)"}
                borderRadius={"0.75rem"}
            >
                <AppIcon
                    w="3.5rem"
                    name={iconName}
                    color="var(--chakra-colors-primaryT50)"
                />
                <Text textStyle={"mediumMd"}>
                    {uploadLabel ? uploadLabel : t("cmn:label.browseFile")}
                </Text>
                {fileName && <Text textStyle={"mediumSm"}>{fileName}</Text>}
                {/* <Flex
                    flexDir={"column"}
                    border={"1px solid var(--chakra-colors-primaryT70)"}
                    borderRadius={"0.50rem"}
                    px={6}
                    py={4}
                    mt={8}
                    gap={3}
                    justifyContent={"center"}
                    w={"full"}
                >
                    <Flex justifyContent={"space-between"}>
                        <HStack gap={6}>
                            <Box alignSelf="center">
                                <AppIcon
                                    w="2rem"
                                    name="icl-document"
                                    color="var(--chakra-colors-greyT70)"
                                />
                            </Box>
                            <VStack gap={1} alignItems={"flex-start"}>
                                <Text textStyle={"mediumMd"}>
                                    Acopad-students-list
                                </Text>
                                <HStack gap={4}>
                                    <Text
                                        color={
                                            "var(--chakra-colors-contentT40)"
                                        }
                                    >
                                        32.9 MB
                                    </Text>
                                    <Text
                                        color={
                                            "var(--chakra-colors-contentT40)"
                                        }
                                    >
                                        2 sec left
                                    </Text>
                                </HStack>
                            </VStack>
                        </HStack>
                        <VStack
                            gap={1}
                            alignItems={"center"}
                            justifyContent={"space-between"}
                        >
                            <AppIcon name="icl-x" />
                            <Text color={"var(--chakra-colors-contentT40)"}>
                                65%
                            </Text>
                        </VStack>
                    </Flex>
                    <Progress
                        colorScheme="green"
                        value={50}
                        height={"0.25rem"}
                        borderRadius={"0.25rem"}
                    />
                </Flex> */}
            </VStack>
            <Stack
                mt={4}
                gap={{
                    base: 4,
                    sm: 8,
                }}
                justifyContent={"space-between"}
                direction={{
                    base: "column",
                    sm: "row",
                }}
            >
                <HStack flexWrap={"wrap"} gap={1.5}>
                    <Text textDecoration={"underline"}>
                        {t("cmn:label.supportedFiles")}
                    </Text>
                    <Text>{fileTypeInfo?.allowType?.join(", ")}</Text>
                </HStack>
                <HStack alignSelf={"flex-start"}>
                    <Text whiteSpace={"nowrap"} textDecoration={"underline"}>
                        {t("cmn:label.maximumSize")}
                    </Text>
                    <Text>
                        {`${fileTypeInfo.maxSize} ${t("cmn:label.fileSizeMb")}`}
                    </Text>
                </HStack>
            </Stack>
            <Input
                opacity={0}
                position={"absolute"}
                w={"full"}
                h={"180px"}
                id="document-upload"
                type="file"
                accept={fileTypeInfo?.allowType}
                cursor={"pointer"}
                top={0}
                left={0}
                onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) {
                        if (
                            file &&
                            fileTypeInfo.maxSize &&
                            file.size > fileTypeInfo.maxSize * 1024 * 1024
                        ) {
                            alert("File is too big! Maximum size is 2 MB.");
                            setErrorMsg(
                                t("cmn:val.fileSize.notValid", {
                                    size: fileTypeInfo.maxSize,
                                })
                            );
                        } else {
                            onFileSelect(file);
                        }
                    }
                    e.target.value = "";
                }}
            />
            {errorMessage && (
                <Text color="var(--chakra-colors-destructive)" mt={2}>
                    {errorMsg || errorMessage}
                </Text>
            )}
        </Flex>
    );
};
